<script setup lang="ts">
import { calendar } from "ionicons/icons";
import {
  IonPage,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
  IonContent,
  IonButton,
} from "@ionic/vue";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import EventCard from "@/views/_partials/EventCard.vue";
import { useAppStore } from "@/stores/app";
import { computed, onMounted } from "vue";
import { usePlansStore } from "@/stores/plans";
import { getSubscribedPlans } from "@/api/plans";

const userStore = useUserStore();
const appStore = useAppStore();
const plansStore = usePlansStore();

const { isMobile } = useWindowWidth();
const dark_mode = computed(() => appStore.settings.theme === "dark");
const limit_events_reached = computed(() => userStore.related.events.length >= plansStore.currentPlan.check_in_max_events)

onMounted(() => {
  fetchCurrentPlan();
})

const fetchCurrentPlan = async () => {
  await plansStore.fetch({ reset: true, page_size: 10 });

  const plan = await getSubscribedPlans();
  let response = plan.data.results;

  let current_plan_id = 0;

 response.forEach((element: any) => {
    if (element.subscription_status === "active") {
      current_plan_id = element.payment_plan;
      return;
    }
  });

  // Get plan information
  await plansStore.fetchPlan(current_plan_id);
};

</script>

<template>
  <ion-page>
    <ion-content>
      <section :class="dark_mode ? '' : 'colored-bg'">
        <!-- <img
          src="@/assets/Checkin_logomarca_Color_2.svg"
          style="width: 14rem"
          alt=""
        /> -->
        <div class="container">
          <h1>Hello there</h1>
          <p>What do you want to do today?</p>
          <template v-if="isMobile && userStore.related.events">
            <EventCard :event="event" :route="`/event/${event.id}/home`" v-for="event in userStore.related.events"
              :key="`event-${event.id}`" />

            <hr />
          </template>
          <div class="flex-desktop">
            <ion-card class="new_event-card" router-link="/onboarding/new-event" :disabled="limit_events_reached">
              <ion-card-header>
                <ion-card-subtitle>
                  <ion-icon :icon="calendar"></ion-icon>
                </ion-card-subtitle>
                <ion-card-title> Create New Event </ion-card-title>
              </ion-card-header>

              <ion-card-content>
                <p>Start from scratch and build your event.</p>
              </ion-card-content>
            </ion-card>

            <ion-card class="my_account-card">
              <ion-card-header>
                <ion-card-subtitle>
                  <ion-icon :icon="calendar"></ion-icon>
                </ion-card-subtitle>
                <ion-card-title> My Account </ion-card-title>
              </ion-card-header>

              <ion-card-content>
                <p>
                  Set up your profile and easily create, publish, and manage
                  your events.
                </p>
                <ion-button color="primary" class="ion-margin-top" router-link="/my-account">
                  Go to my account
                </ion-button>
              </ion-card-content>
            </ion-card>
          </div>
          <template v-if="!isMobile && userStore.related.events">
            <div class="flex-desktop" style="flex-wrap: wrap; justify-content: space-between">
              <EventCard :event="event" :route="`/event/${event.id}/home`" v-for="event in userStore.related.events"
                :key="`event-${event.id}`" />
            </div>
          </template>
        </div>
      </section>
    </ion-content>
  </ion-page>
</template>
<style lang="scss" scoped>
ion-title {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

@media (min-width: 768px) {}
</style>

<style lang="scss">
.new_event-card {
  --background: var(--ion-color-primary);

  ion-card-title {
    --color: var(--ion-color-light-shade);
  }

  ion-card-subtitle {
    --color: var(--ion-color-light);
  }

  --ion-card-color: var(--ion-color-light);
  cursor: pointer;
}

.new_event-card,
.my_account-card {
  ion-card-subtitle {
    font-size: 2rem;
  }
}

@media (min-width: 768px) {

  .new_event-card,
  .my_account-card {
    width: 50%;
    height: 230px;
  }

  .new_event-card {
    margin-right: 15px;
  }

  .my_account-card {
    margin-left: 15px;
  }

  .colored-bg {
    min-height: calc(100vh - 72px);
  }
}
</style>
